/* eslint no-eval: 0 */
import { Link, navigate } from "gatsby"
import addToMailchimp from 'gatsby-plugin-mailchimp'
import PropTypes from "prop-types"
import React from "react"
import { useEffect } from "react"
import { useLayoutEffect } from "react"
import { useState } from "react"
import { useRef } from "react"
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import styled from 'styled-components'
import SearchLogo from '../fonts/search.svg'
import "../style.scss"
import Footer from "./footer"
import Header from "./header"
import Livefb from "./live"


let time_to_close = 5000;
var toastId;

// const getMethods = (obj) => {
//   let properties = new Set()
//   let currentObj = obj
//   do {
//     Object.getOwnPropertyNames(currentObj).map(item => properties.add(item))
//   } while ((currentObj = Object.getPrototypeOf(currentObj)))
//   return [...properties.keys()].filter(item => typeof obj[item] === 'function')
// }

//Firebase init
/*const app = firebase.initializeApp({
  apiKey: "AIzaSyCv0vPm63PJbx5e8cm2g7qFOVpU6XyM2hc",
  authDomain: "startupitalia-a6081.firebaseapp.com",
  databaseURL: "https://startupitalia-a6081.firebaseio.com",
  projectId: "startupitalia-a6081",
  storageBucket: "startupitalia-a6081.appspot.com",
  messagingSenderId: "1051294898184",
  appId: "1:1051294898184:web:0fa2091bbb674127c819bd",
  measurementId: "G-VJWRFSY7FB"
});*/


const DivUnread = styled.div`
display: block;
  border-radius: 5px;
  background: #D22;
  width: 18px;
  height: 18px;
  font-size: 10px;
  text-align: center;
  color: white;
  margin-left: 5px;
  margin-top: 2px;
  display: none;
`
// function showWelcomeMessage (remote) {
//   //window.alert('Welcome: '+remote.getValue('welcome_message').asString() );
//   console.log('Welcome: '+remote.getValue('welcome_message').asString() )
// }


//Firebase remote config read
if (typeof window !== 'undefined') {
  /*testconst remote = firebase.remoteConfig();

  remote.settings = {
    minimumFetchIntervalMillis: 3600000,
  };

  remote.defaultConfig = ({
    'welcome_message': 'Welcome',
  });

  remote.fetchAndActivate()
    .then(() => {
      showWelcomeMessage(remote);
    })
    .catch((err) => {
      console.error(err);
    });
    */
}

var selected;
var selectedLine;

var array_selected={
  menu_desk_search:"#D2227B",
  menu_desk_tech:"#D2227B",
  menu_desk_economy:"#E5CB52",
  menu_desk_education:"#EF767E",
  menu_desk_lifestyle:"#43BDCC",
  menu_desk_startup:"#39CD62",
  menu_desk_impact:"#7F8CD1",
  menu_desk_agenda:"#7F8CD1",
  menu_desk_bandi:"#7F8CD1",
  menu_desk_my:"#7F8CD1",
  menu_desk_option:"#7F8CD1",
  menu_desk_default:"#7F8CD1",
  menu_desk_life:"linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
  menu_desk_valoreresponsabile:"linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
  menu_desk_smartmoney:"linear-gradient(53.35deg, rgb(238, 61, 73) 0%, rgb(203, 53, 107) 100%)",
  menu_desk_about_us: "#7F8CD1",
  menu_desk_investor: "#7F8CD1",
  menu_desk_unstoppablewomen: "#7F8CD1"
}

var array=[
  "menu_desk_search",
  "menu_desk_tech",
  "menu_desk_economy",
  "menu_desk_education",
  "menu_desk_lifestyle",
  "menu_desk_startup",

  "menu_desk_impact",
  "menu_desk_agenda",
  "menu_desk_bandi",
  "menu_desk_my",
  "menu_desk_option",
  "menu_desk_life",
  "menu_desk_valoreresponsabile",
  "menu_desk_smartmoney",

  "menu_desk_about_us",
  "menu_desk_investor" ,
  "menu_desk_unstoppablewomen"
]

function subscribe (email) {
  subscribe_real(email, {
    //FNAME: "Tobia",
    //LNAME: "Caneschi",
    'group[1][1]':1,
    'gdpr[9]':'Y',
  })
}

function subscribe_real(email, listFields){
  addToMailchimp(email, listFields) // listFields are optional if you are only capturing the email address.
    .then(data => {
      // I recommend setting data to React state
      // but you can do whatever you want (including ignoring this `then()` altogether)
      //console.log(data);

      if (data.result === "success") {
        if (typeof window !== 'undefined') {
          window.document.getElementById('button_email').style.display = "none";
          window.document.getElementById('email').style.display = "none";
          window.document.getElementById('email').style.display = "none";
          window.document.getElementById('responseByMailchimp').innerHTML = data.msg;
          toast.dismiss(toastId);
          window.localStorage.setItem("newsletter_ok_time", Date.now());
        }

        toastId = toast("Grazie! Ci vediamo per il caffè",{
          autoClose: time_to_close,
          hideProgressBar: true,
          //position: toast.POSITION.BOTTOM_RIGHT,
          });

      } else {
        if (typeof window !== 'undefined') {
        //document.getElementById('button_email').style.display = "block";
          window.document.getElementById('responseByMailchimp').innerHTML = "Errore di iscrizione:<br>"+data.msg;
        }
      }
    })
    .catch(() => {
      // unnecessary because Mailchimp only ever
      // returns a 200 status code
      // see below for how to handle errors
    })
}

const Msg = ({ closeToast, link }) => (
  <div>
    <center>
      <p style={{fontSize: "14px", fontWeight: "800", color: "black"}}>
        UN <span role="img" aria-label="coffe">☕</span> CON STARTUPITALIA?
      </p>
    </center>
    <p style={{fontSize: "14px", marginTop: "-10px"}}>Ogni settimana una selezione delle migliori news nella tua casella di posta</p>
    <input onClick={() => { document.getElementById('email').style.background = "none"; document.getElementById('text_privacy').style.background = "none" }} style={{fontSize: "14px"}} id="email" type="email" placeholder="metti la tua mail" name="email" size="28" />
     <p className="text_privacy" id="text_privacy">
     <input onClick={() => { document.getElementById('email').style.background = "none"; document.getElementById('text_privacy').style.background = "none" }} id="check_newletter" type="checkbox" name="checkbox_newletter" style={{marginTop: "10px"}}/> Inviando il form acconsenti al trattamento dei <a href="/privacy" target="_blank">dati personali</a></p>
    <div style={{marginTop: "16px"}} >
      <button id="button_email" style={{marginTop: "16px", width: "6rem"}} onClick={()=>{
        var err = 0;
        document.getElementById('responseByMailchimp').innerHTML="";
        if (document.getElementById('email').value === "") {
          document.getElementById('email').style.background = "#ff000021";
          document.getElementById('responseByMailchimp').innerHTML="🙏 <b> Scrivi la tua mail</b>";
          err++;
        }

        if (!document.getElementById('check_newletter').checked) {
          document.getElementById('text_privacy').style.background = "#ff000021";
          document.getElementById('responseByMailchimp').innerHTML+= (err>0?" e<br><b>conferma la privacy</b>":"🙏 <b>Devi confermare la privacy</b>");
          err++;
        }

        if (err) return;

        if (document.getElementById('email').value !== "" && document.getElementById('check_newletter').value !== 0) {
          subscribe(document.getElementById('email').value);
        }
      }}> &nbsp;&nbsp;OK&nbsp;&nbsp; </button>
      <button id="mailchimp_no_thanks" onClick={()=>closeToast()} style={{width: "6rem"}}>No grazie</button>
    </div>
    <div style={{fontSize:"14px"}} id="responseByMailchimp"></div>
  </div>
)

var newsletter_alert = true;

var time_to_alert = 5000;

var DivLogo = "";
var DivLogoHome = "";

// var div_logo_sidebar = "div_logo_sidebar_home";
var div_logo_page = "div_logo_page_home";

//home
// div_logo_sidebar = "div_logo_sidebar_home";
// div_logo_page = "div_logo_page_home";
DivLogo = styled.div`
  width: 75%;
  margin-left: 23px;
  @media only screen and (min-width: 700px) {
    width: 65%;
    margin-left: 23px;
    display: block;
  }

  @media only screen and (max-width: 699px) {
    display: none;
  }
`
DivLogoHome = styled.div`
  width: 44%;
  padding-left: 2%;
  height: auto;
  margin: auto;
  @media only screen and (min-width: 700px) {
    width: ;
    margin: auto;
    display: block;
  }

  @media only screen and (max-width: 699px) {
    display: none !important;
  }
`

const DesktopContent = styled.div`
  margin-left: 0%;
  // @media only screen and (min-width: 700px) {
  //   margin-left: 28%;
  // }

  @media only screen and (min-width: 1024px) {
    margin-left: 17%;
  }


`


const DivContainerDesktop = styled.div`
  @media only screen and (max-width: 699px) {
    display: none !important;
    margin-right: 0px;
  }
  @media only screen and (min-width: 700px) {
    display: inline !important;
  }
`

const DivDeskSection = styled.div`
  border-radius: 0 100px 100px 0;
  background-color: #F1F1F1;
  width: 100px;
  height: 21px;
  font-size: 12px;
  font-family:"urw-din";
  font-weight: 400;
  letter-spacing: 0.48px;
  padding-left: 25px;
  margin-top: 20px;
  margin-bottom: 10px;
`

const DivReturnTop = styled.img`
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  height: fit-content;
  width: fit-content;
  position: fixed;
  bottom:0;
  right:0;
  margin-bottom: 20px;
  margin-right:20px;
  transform: rotate(0deg);
  display: none;
  z-index: 98;

  @media only screen and (min-width: 700px) {
    margin-bottom: 20px;
    margin-right:20px;
  }

  @media only screen and (max-width: 699px) {
    margin-bottom: -5px;
    margin-right: -5px;
  }
`

const DivDeskMenu = styled.div`
  text-transform: uppercase;
  font-family: "aktiv-grotesk";
  font-size: 13px;
  color: #585858;
  font-weight: 800;
  clear: both;
`

// const DivDeskMenuCerca = styled.div`
//   margin-top:40px;
//   padding-left: 10px;
//   font-family: "aktiv-grotesk";
//   font-weight: 800;
//   margin: 2px 10px 2px 20px;
//   clear: both;
//   color: #232323;
//   font-size: 17px;
//   letter-spacing: 0.69px;
//   line-height: 21px;
// `

const DivLine = styled.div`
    height: 2px;
    width: 100%;
    border-bottom: 1px solid rgb(237, 237, 237, 0.5);
`
const StyleDiv = styled.div`
  display:inline;
  margin-right: 3vh;
  height: 32px;
  width: 6px;
  float: left;
`
const DivMenuTitle = styled.div`
  font-family: "aktiv-grotesk";
  font-weight: 800;
  display:flex;
  color: black;
  padding-top: 5px;
  padding-bottom: 5px;
`

const ImgLogo = styled.img`
  width: 466px;
  height: auto;
  margin-top: 20px;
  display: inline;
`
const ImgLogoSidebar = styled.img`
  width: 100%;
  height: auto;
  margin-top: 20px;
  display: inline;
`

// var Menu_visibility = "hidden";

function MenuVoice({background, style_div_id, style_div_menut_title_id, to, text}) {
  return <DivDeskMenu
    className="menu_desk_line  "
    // style={{display: "none"}}
  >
      <StyleDiv
        id={style_div_id}
        className="menu_line"
        style={{background: background}}>
      </StyleDiv>
      <Link
        duration={0.3}
        style={{height:"55px",paddingTop:"8px"}}
        // style={{display:"none"}}
        to={to}
      >
        <DivMenuTitle
          id={style_div_menut_title_id}
          // style={{display:"none"}}
        >
          {text}
        </DivMenuTitle>
      </Link>
    </DivDeskMenu>
}

function Layout ({ children, classNames, display_sidebar_logo, display_page_logo, pathname, primary_category, vertical }) {
  //console.log("tobiajs: Layout");
  vertical = children.props.pageContext.vertical
  primary_category = children.props.pageContext.primary_category

  // const [scrolled, setScrolled] = useState(false);

  const [searchQ, setSearchQ] = useState('');
  const [isSearchPage, setIsSearchPage] = useState(false);
  // const history = useHistory();
  // useEffect(() => {
  //   let path = window.location.pathname;
  //   let pathArray = path.split('/');
  //   console.log('pathArray', pathArray);
  //   if (path.startsWith('/search') || (pathArray.length >= 1 && pathArray[1] === 'search')) {
  //     setIsSearchPage(true);
  //   } else {
  //     setIsSearchPage(false);
  //   }
  // }, []);

  // var old_scrolled_down = false;
  // var old_scrolled_down_header_mobile = false;
  // var oldscrollY = 0;

  const oldscrollY = useRef(0);
  const old_scrolled_down = useRef(false);
  const old_scrolled_down_header_mobile = useRef(false);

  // var visibility_timeout;

  function setMenuCategory(category, menupath) {
    console.log("checkjs setMenuCategory category" + category + " menupath " + menupath);
    if (category !== "" && array.includes('menu_desk_'+category.toLowerCase())) {
      //window.alert(category.name)  ;
      return category.toLowerCase();

    } else {
      return menupath;
    }
  }

  async function isFileFound(url) {
    try {
      const requestOptions = {
        credentials: "omit",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        method: "GET",
        mode: "cors",
      };
      const response = await fetch(
        url,
        requestOptions
      );
      return response.json();
    } catch (error) {
      return false;
    }
  }

  useEffect(() => {
    const refreshInterval = setInterval(() => {
      if (window.location.hostname.match('startupitalia')) {
        try {
          // isFileFound("http://localhost:8000/last_deploy.json").then(
          isFileFound("https://startupitalia.eu/last_deploy.json").then(
            (data) => {
              let date_str = data.date;
              if (!window.deployDate) {
                window.deployDate = date_str;
              } else if (window.deployDate !== date_str) {
                window.location.reload();
              }
            }
          );
        } catch (err) {
          console.error(err);
        }
      }
    }, 5000);
    return () => {
      clearInterval(refreshInterval);
    };
  }, []);

   useLayoutEffect(()=>{

      let path = window.location.pathname;
      let pathArray = path.split('/');
      // console.log('pathArray', pathArray);
      if (path.startsWith('/search') || (pathArray.length >= 1 && pathArray[1] === 'search')) {
        setIsSearchPage(true);
      } else {
        setIsSearchPage(false);
      }

      var div_content = document.getElementById("div_content")
      if (div_content && window.location.pathname === "/") {
        div_content.classList.add("site-content-parent-home")
      } else {
        div_content.classList.remove("site-content-parent-home")
      }

      console.log('Layout useLayoutEffect up');

      const handleScroll = () => {
        //console.log("scolltop:"+window.scrollTop);
        var scrolled_down_header_mobile = window.scrollY >= 28;
        var scrolled_down_header_mobile_hide = window.scrollY >= 218;

        var diff = window.scrollY - oldscrollY.current;
        var x;
        if (scrolled_down_header_mobile_hide) {
          if ( diff > 0) {
            x = document.getElementById("byline_mobile");
            if (x && !x.classList.contains("hide_anim")) {
               x.classList.add("hide_anim");
             }
           } else {
             x = document.getElementById("byline_mobile");
             if (x && x.classList.contains("hide_anim")) {
               x.classList.remove("hide_anim");
             }
           }
         } else {
           x = document.getElementById("byline_mobile");
           if (x) x.classList.remove("hide_anim");
         }

         oldscrollY.current = window.scrollY;

        if (document.getElementById('newmag_mobile_primary_category') && !(old_scrolled_down_header_mobile.current === scrolled_down_header_mobile || !document.getElementById('byline_mobile'))) {
          if (scrolled_down_header_mobile) {

            document.getElementById('newmag_mobile_primary_category').style.padding = "4px";
            document.getElementById('newmag_mobile_primary_category').style.marginTop = "9px";
            document.getElementById('byline_mobile').style.position = "fixed";
            document.getElementById('byline_mobile').style.top = "58px";
            document.getElementById('byline_mobile').style.zIndex = "995";
            document.getElementById('posted_on_mobile').style.marginTop="3px";
            document.getElementById('posted_on_mobile').style.marginBottom="10px";
          } else {
            document.getElementById('newmag_mobile_primary_category').style.padding = "10px";
            document.getElementById('newmag_mobile_primary_category').style.marginTop = "0px";
            document.getElementById('byline_mobile').style.position = "relative";
            document.getElementById('byline_mobile').style.top="";
            document.getElementById('byline_mobile').style.zIndex = "1";
            document.getElementById('posted_on_mobile').style.marginTop="20px";
            document.getElementById('posted_on_mobile').style.marginBottom="15px";
          }

          old_scrolled_down_header_mobile.current = scrolled_down_header_mobile;
        }

        var scrolled_down = window.scrollY >= 1400;

        if (old_scrolled_down.current !== scrolled_down && document.getElementById('newmag_img_return')) {
          if (scrolled_down) {
            if (document.getElementById('newmag_img_return').style.display !== "block") {
              //alert("visualizzo return to top");
             document.getElementById('newmag_img_return').style.display = "block";
             }
          } else {
            if (document.getElementById('newmag_img_return').style.display !== "none")
            document.getElementById('newmag_img_return').style.display = "none";
          }

          old_scrolled_down.current = scrolled_down;
        }
      };


      window.addEventListener("scroll", handleScroll);

      //alert('mobile_logo visible')
      /*document.getElementById('mag_desktop_sidebar').style.visibility = "visible";
      document.getElementById('burger_menu').style.visibility = "visible";
      document.getElementById('mobile_logo').style.visibility = "visible";
      document.getElementById('mobile_mini_logo').style.visibility = "visible";
      document.getElementById('home_logo_desktop').style.visibility = "visible";*/

      var menupath = window.location.pathname.split('/')[1];

      console.log("menupath rewrite pre: "+menupath);

      if (!array.includes(menupath) && primary_category) {
          menupath = primary_category.toLowerCase()
          console.log("menupath rewrite replace: "+menupath);
      }

      const mouseTargets = document.getElementsByClassName('menu_desk_line');

      function reset_menu() {
        Array.from(mouseTargets).forEach((mouseTarget, index) => {
          Array.from(mouseTarget.children).forEach((child, index) => {
              setOverlay(child, false);
            });
        });
      }

      reset_menu();

      Array.from(mouseTargets).forEach((mouseTarget, index) => {
        mouseTarget.addEventListener('mouseenter', e => {
          Array.from(mouseTarget.children).forEach((child, index) => {
            setOverlay(child, true);
          });
        });

        mouseTarget.addEventListener('mouseleave', e => {
          Array.from(mouseTarget.children).forEach((child, index) => {
            setOverlay(child, false);
          });
        });
      });

      try {

        console.log('useLayoutEffect cerco menu pre menu_desk_'+menupath);

        if (!array.includes('menu_desk_'+menupath)) {
          console.log('useLayoutEffect cerco menu selected '+selected);
          //console.log('useLayoutEffect cerco menu categories '+children[1].props.children[2].props.categories);
          //console.log(children);
          window.chi = children.props.pageContext;


          menupath = setMenuCategory(children.props.pageContext.primary_category, menupath)


        }
      } catch {}

      console.log('useLayoutEffect cerco menu menu_desk_'+menupath);

      var catmenu = menupath
      if (vertical && vertical !== 'www') catmenu = vertical

      if (catmenu !== "" && array.includes('menu_desk_'+catmenu) ) {
        console.log('useLayoutEffect coloro menu menu_desk_'+catmenu);
        if (window.document.getElementById('menu_desk_'+catmenu) ) {
          //alert('trovato menu selected');
          window.document.getElementById('menu_desk_'+catmenu).style.color = array_selected['menu_desk_'+catmenu];
          //console.log('pre menu_desk_line_'+menupath+' '+window.document.getElementById('menu_desk_line_'+menupath).style.opacity);
          window.document.getElementById('menu_desk_line_'+catmenu).style.opacity = 1;
          window.document.getElementById('menu_desk_line_'+catmenu).style.background = array_selected['menu_desk_'+catmenu];
        }
      } else if (menupath === '/' || menupath === '') {
        document.getElementById('home_logo_desktop').style.display = "block";
      }

      if (menupath === '/' || menupath === '') {
        document.getElementById('home_logo_desktop').style.display = "block";
      } else {
        document.getElementById('home_logo_desktop').style.display = "none";
      }

      function setOverlay (child, active) {
        //console.log('menu_desk_line_ enter :');
        //reset_menu();
        menupath = window.location.pathname.split('/')[1];
        if (child.classList.contains('menu_line') && (active || (!active && child.id !== 'menu_desk_line_'+menupath))) {
          if (child.style.opacity !== active?1:0) {
            // console.log('menu_desk_line_ enter :'+active+' menu_desk_line_'+menupath);
            child.style.opacity = active?1:0;
            child.style.background = array_selected[child.id.replace("_line","")]
          }
        }
      }

    return () => {
        console.log('Layout useLayoutEffect down');
        Array.from(mouseTargets).forEach((mouseTarget, index) => {
          mouseTarget.removeEventListener('mouseenter', e => {
            Array.from(mouseTarget.children).forEach((child, index) => {
              setOverlay(child, true);
            });
          });

          mouseTarget.removeEventListener('mouseleave', e => {
            //console.log('menu_desk_line_ leave'+' menu_desk_line_'+menupath);
            Array.from(mouseTarget.children).forEach((child, index) => {
              setOverlay(child, false);
            });
          });
        });

        document.removeEventListener('scroll', handleScroll);
    };
  }, [primary_category, vertical, children.props.pageContext]);;


  if (typeof window !== 'undefined') {
    if (window.innerWidth>=500) {
      toast.configure({
        hideProgressBar: false,
        position: toast.POSITION.TOP_RIGHT,
        //draggable: false,
        //etc you get the idea
      });
    } else {
      toast.configure({
        hideProgressBar: false,
        position: toast.POSITION.BOTTOM_CENTER,
        //draggable: false,
        //etc you get the idea
      });
    }

    if (window.localStorage.getItem('newsletter_alert') !== null) {
      newsletter_alert = window.localStorage.getItem('newsletter_alert');
      if (window.localStorage.getItem("newsletter_time") !== null) {
        //window.alert("newsletter diff: "+(Date.now() - window.localStorage.getItem("newsletter_time")));
        newsletter_alert = (Date.now() - window.localStorage.getItem("newsletter_time")) > 1000*(3600*24) ? "true":"false";
      }
    }

    if (newsletter_alert !== "false") {
        //alert("newletter attiva: "+newsletter_alert);
        toastId = toast(<Msg />,{
          hideProgressBar: false,
          autoClose: false,
          //pauseOnHover: true,
          delay: time_to_alert, closeOnClick: false }
        );
        window.localStorage.setItem("newsletter_time", Date.now());
        window.localStorage.setItem('newsletter_alert', false);
    }

    if (window.localStorage.getItem('menu_visible') ) {

      if (window.localStorage.getItem('menu_visible')>1) {
        //console.log("tobiajs: menu visible");
        // Menu_visibility = "visible";
      } else {
        var menu_visible = parseInt(window.localStorage.getItem('menu_visible'));
        window.localStorage.setItem('menu_visible', menu_visible+1);
      }
    } else {
      //console.log("tobiajs: menu not visible init");
      window.localStorage.setItem('menu_visible', 1);
    }
  }

  return (
  <div id="page" className={`site ${classNames}`}
    // data-active={scrolled}
    >

    <div><Livefb></Livefb></div>
    {/*<iframe className="iframe_live" style={{display: "block"}} src="/live?aa" className="live_overlay_iframe"></iframe>*/}
    <Header siteTitle={"StartupItalia"} vertical={vertical}/>
    <DivReturnTop className="newmag_return_top" style={{display: "none"}} onClick={()=>{window.scrollTo({top: 0,behavior: 'smooth'});}} id="newmag_img_return" src={"/img/return_home.png"}></DivReturnTop>
    <DivContainerDesktop style={{display: 'none'}}>
    <div id="mag_desktop_sidebar" className="mag_desktop_sidebar" style={{overflowY: 'auto'}}>
    <DivLogo id="mag_desktop_sidebar_logo" style={{}}  className="div_logo_sidebar_home"><Link  duration={0.3} to="/"  rel="home"><ImgLogoSidebar src={"/img/logo_startupitalia@2x.png"} alt={"Torna alla home"}/></Link></DivLogo>
    <DivLine style={{marginTop:"10px", marginBottom:"10px"}}></DivLine>
     {
        (isSearchPage) && (
          <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_search" style={selectedLine && selectedLine['search']?selectedLine['search']:{}} className="menu_line" ></StyleDiv><DivMenuTitle style={selected && selected['search']?selected['search']:{}}  id="menu_desk_search">Search</DivMenuTitle></DivDeskMenu>
        )
      }

      {  (!isSearchPage) && (<DivDeskMenu style={{display: isSearchPage?"none":""}} className="menu_desk_line  ">
            <StyleDiv id="menu_desk_line_tech"
              style={selectedLine && selectedLine['tech']?selectedLine['tech']:{}}
              className="menu_line">
            </StyleDiv>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <input
                placeholder={'Cerca...'}
                style={{background: "inherit", color: "inherit", height: "25px", padding: "5px", width:"80%", fontFamily: "", fontSize: "18px", fontWeight: "900",border: "0px solid", paddingTop:"8px", flex: 2}}
                onChange={(e) => setSearchQ(e.target.value)}
                onKeyDown={(e) => {if (e.key === 'Enter') {navigate(`/search?s=${searchQ}`)}}}
                />
              <button style={{background: 'transparent'}} onClick={() => {navigate(`/search?s=${searchQ}`); }}>
                <img src={SearchLogo} style={{flex: 1, height: "1.5rem"}} alt={"Search"}
                />
              </button>
            </div>
          </DivDeskMenu>
        )
      }
      <DivLine style={{marginTop:"10px", marginBottom: "28px"}}></DivLine>

      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_life" style={selectedLine && selectedLine['life']?selectedLine['life']:{}} className="menu_line" ></StyleDiv><Link duration={0.3} to="/life/" rel="home"><DivMenuTitle style={selected && selected['life']?selected['life']:{}}  id="menu_desk_life">Life</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_smartmoney" style={selectedLine && selectedLine['smartmoney']?selectedLine['smartmoney']:{}} className="menu_line" ></StyleDiv><Link duration={0.3} to="/smartmoney/" rel="home"><DivMenuTitle style={selected && selected['smartmoney']?selected['smartmoney']:{}}  id="menu_desk_smartmoney">Smart Money</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_valoreresponsabile" style={selectedLine && selectedLine['valoreresponsabile']?selectedLine['valoreresponsabile']:{}} className="menu_line" ></StyleDiv><Link duration={0.3} to="/valoreresponsabile/" rel="home"><DivMenuTitle style={selected && selected['valoreresponsabile']?selected['valoreresponsabile']:{}}  id="menu_desk_valoreresponsabile">Valore Responsabile</DivMenuTitle></Link></DivDeskMenu>

      <DivLine style={{marginTop:"28px", marginBottom: "28px"}}></DivLine>

      <DivDeskMenu className="menu_desk_line  ">
        <StyleDiv id="menu_desk_line_economy"
        style={selectedLine && selectedLine['economy']?selectedLine['economy']:{}}
        className="menu_line">
        </StyleDiv>
          <Link  duration={0.1}
          style={{height:"55px",paddingTop:"8px"}}
          to='/economy/'>
            <DivMenuTitle id="menu_desk_economy">Economy</DivMenuTitle>
          </Link>
      </DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_education" style={selectedLine && selectedLine['education']?selectedLine['education']:{}} className="menu_line"></StyleDiv><Link  duration={0.1} style={{height:"55px",paddingTop:"8px"}} to='/education/'><DivMenuTitle id="menu_desk_education">Education</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_impact" style={selectedLine && selectedLine['impact']?selectedLine['impact']:{}} className="menu_line"></StyleDiv><Link  duration={0.3} style={{height:"55px",paddingTop:"8px"}} to='/impact/'><DivMenuTitle style={selected && selected['impact']?selected['impact']:{}} id="menu_desk_impact">Impact</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_lifestyle" style={selectedLine && selectedLine['lifestyle']?selectedLine['lifestyle']:{}} className="menu_line"></StyleDiv><Link  duration={0.1} style={{height:"55px",paddingTop:"8px"}} to='/lifestyle/'><DivMenuTitle style={selected && selected['lifestyle']?selected['lifestyle']:{}} id="menu_desk_lifestyle">Lifestyle</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_startup" style={selectedLine && selectedLine['startup']?selectedLine['startup']:{}} className="menu_line"></StyleDiv><Link  duration={0.3} style={{height:"55px",paddingTop:"8px"}} to='/startup/'><DivMenuTitle style={selected && selected['startup']?selected['startup']:{}} id="menu_desk_startup">Startup</DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  "><StyleDiv id="menu_desk_line_tech"  style={selectedLine && selectedLine['tech']?selectedLine['tech']:{}} className="menu_line"></StyleDiv><Link hex="#FFFFFF" duration={1} style={{height:"55px",paddingTop:"8px"}} to='/tech/'><DivMenuTitle id="menu_desk_tech">Tech</DivMenuTitle></Link></DivDeskMenu>

      <DivLine style={{marginTop:"28px", marginBottom: "28px"}}></DivLine>

      <DivDeskMenu className="menu_desk_line  ">
        <StyleDiv
          id="menu_desk_line_default"
          // style={selectedLine && selectedLine['agenda']?selectedLine['agenda']:{}}
          className="menu_line">
        </StyleDiv>
        <Link
          duration={0.3}
          style={{height:"55px",paddingTop:"8px"}}
          to='https://startupitaliaopensummit.eu/'
          target="_blank"
        >
          <DivMenuTitle
            // style={selected && selected['agenda']?selected['agenda']:{}}
            id="menu_desk_default">
              SIOS21
          </DivMenuTitle>
        </Link>
      </DivDeskMenu>

      <DivDeskMenu className="menu_desk_line  ">
        <StyleDiv
          id="menu_desk_line_default"
          // style={selectedLine && selectedLine['agenda']?selectedLine['agenda']:{}}
          className="menu_line">
        </StyleDiv>
        <Link
          duration={0.3}
          style={{height:"55px",paddingTop:"8px"}}
          to='https://shopping.startupitalia.eu/'
          target="_blank"
        >
          <DivMenuTitle
            // style={selected && selected['agenda']?selected['agenda']:{}}
            id="menu_desk_default">
              Shopping
          </DivMenuTitle>
        </Link>
      </DivDeskMenu>

      <DivDeskMenu className="menu_desk_line  ">
        <StyleDiv
          id="menu_desk_line_agenda"
          style={selectedLine && selectedLine['agenda']?selectedLine['agenda']:{}}
          className="menu_line">
        </StyleDiv>
        <Link duration={0.3} style={{height:"55px",paddingTop:"8px"}} to='/agenda/'>
          <DivMenuTitle
            style={selected && selected['agenda']?selected['agenda']:{}}
            id="menu_desk_agenda">
              Agenda
          </DivMenuTitle>
        </Link>
      </DivDeskMenu>
      <DivDeskMenu className="menu_desk_line  ">
        <StyleDiv
          id="menu_desk_line_bandi"
          style={selectedLine && selectedLine['bandi']?selectedLine['bandi']:{}}
          className="menu_line">
        </StyleDiv>
        <Link  duration={0.3} style={{height:"55px",paddingTop:"8px"}} to='/bandi/'>
          <DivMenuTitle
            style={selected && selected['bandi']?selected['bandi']:{}} id="menu_desk_bandi">
              Bandi
          </DivMenuTitle>
        </Link>
      </DivDeskMenu>

      <DivDeskSection className="menu_group">RUBRICHE
      </DivDeskSection>
      <MenuVoice
        background='#7F8CD1'
        style_div_id='menu_desk_line_unstoppablewomen'
        style_div_menut_title_id='menu_desk_unstoppablewomen'
        to='/unstoppablewomen/'
        text="Unstoppable Women"
      />

      {/*
      <MenuVoice
        background='#7F8CD1'
        style_div_id='menu_desk_line_rubrica1'
        style_div_menut_title_id=''
        to='/content-intelligence/'
        text="Content Intelligence"
      />
      <MenuVoice
        background='#7F8CD1'
        style_div_id='menu_desk_line_rubrica2'
        style_div_menut_title_id=''
        to='/humanize/'
        text="Humanize"
      />
      <MenuVoice
        background='#7F8CD1'
        style_div_id='menu_desk_line_rubrica3'
        style_div_menut_title_id=''
        to='/legalmentorship/'
        text="Legal Mentorship"
      />
      <MenuVoice
        background='#7F8CD1'
        style_div_id='menu_desk_line_rubrica4'
        style_div_menut_title_id=''
        to='/lowres/'
        text="Lowres"
      /> */}
      <DivDeskSection className="menu_group">
        MY
      </DivDeskSection>
      <DivDeskMenu className="menu_desk_line " ><StyleDiv id="menu_desk_line_my" className="menu_line" style={selectedLine && selectedLine['my']?selectedLine['my']:{}}></StyleDiv><Link duration={0.3} to="/my"  rel="home"><DivMenuTitle style={selected && selected['my']?selected['my']:{}} id="menu_desk_my" >Articoli Salvati <DivUnread id="unread_menu"></DivUnread></DivMenuTitle></Link></DivDeskMenu>
      <DivDeskMenu className="menu_desk_line " >
        <StyleDiv id="menu_desk_line_option" className="menu_line" style={selectedLine && selectedLine['option']?selectedLine['option']:{}}></StyleDiv>
        <Link duration={0.3} to="/option"  rel="home">
          <DivMenuTitle style={selected && selected['option']?selected['option']:{}} id="menu_desk_option" >Impostazioni</DivMenuTitle>
        </Link>
      </DivDeskMenu>
      <DivDeskSection className="menu_group" style={{width: '140px'}}>STARTUPITALIA
      </DivDeskSection>
      <DivDeskMenu className="menu_desk_line ">
        <StyleDiv id="menu_desk_line_about_us" className="menu_line" style={selectedLine && selectedLine['about-us']?selectedLine['about-us']:{}}></StyleDiv>
        <Link duration={0.3} to="/about-us/" rel="home">
          <DivMenuTitle style={selected && selected['about-us']?selected['about-us']:{}}  id="menu_desk_about_us">Advisory Board</DivMenuTitle>
        </Link>
      </DivDeskMenu>
      <DivDeskMenu className="menu_desk_line "><StyleDiv id="menu_desk_line_investor" className="menu_line" style={selectedLine && selectedLine['investor']?selectedLine['investor']:{}}></StyleDiv>
        <a href={'https://investor.startupitalia.eu/'} target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>
          <DivMenuTitle style={selected && selected['investor']?selected['investor']:{}}  id="menu_desk_investor">Area Investor</DivMenuTitle>
        </a>
      </DivDeskMenu>
      <DivDeskMenu className="menu_desk_line " >
        <StyleDiv id="menu_desk_line_lavora_con_noi" className="menu_line" style={selectedLine && selectedLine['lavora_con_noi']?selectedLine['lavora_con_noi']:{}}></StyleDiv>
        <Link duration={0.3} to="/lavora-con-noi/" rel="home">
          <DivMenuTitle style={selected && selected['lavora_con_noi']?selected['lavora_con_noi']:{}} id="menu_desk_lavora_con_noi" >Lavora con noi</DivMenuTitle>
        </Link>
      </DivDeskMenu>
    </div>
    </DivContainerDesktop>
    <DesktopContent id="div_content" className="site-content-parent">
      <div id="content" className="site-content"  >
        <section id="primary" className="content-area">
          <main id="main" className="site-main">
            <DivLogoHome id="home_logo_desktop" style={{display: display_page_logo}} className={div_logo_page}><center><ImgLogo src={"/img/logo_startupitalia@2x.png"} alt={"Torna alla home"}/></center></DivLogoHome>
            {children}

          </main>
        </section>
      </div>
      <div
        style={{
          margin: `0 auto`,
          paddingTop: 0,
        }}
      >
        {/*}<Livefb />*/}
        <Footer />
      </div>
      <div className="entry-content"></div>
    </DesktopContent>
    <audio id="click" loop={false}>
      <track default
        kind="captions" />
      <source src={"/sound/button_click.mp3"} type={"audio/mpeg"}/>
    </audio>
  </div>
)}

Layout.defaultProps = {
  display_sidebar_logo:"",
  display_page_logo: "none",
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  display_sidebar_logo:PropTypes.string,
  display_page_logo:PropTypes.string
}

export default Layout
